"use client"

import { createContext, useContext, useMemo } from "react"

import { DEFAULT_LANG } from "./config"
import { makeTranslator, type Lang } from "./messages"

const LangContext = createContext<Lang>(DEFAULT_LANG)

/** Ustawiany raz w korzeniu układu; język bierze się z ciasteczka na serwerze. */
export const LangProvider = ({
  lang,
  children,
}: {
  lang: Lang
  children: React.ReactNode
}) => <LangContext.Provider value={lang}>{children}</LangContext.Provider>

export const useLang = (): Lang => useContext(LangContext)

/**
 * Tłumacz dla komponentów klienckich:
 *   const t = useT()
 *   <span>{t("Wybierz rozmiar")}</span>
 */
export const useT = () => {
  const lang = useLang()
  return useMemo(() => makeTranslator(lang), [lang])
}
